import type { StringRecord, ToastRule } from '@types';

export const validateRuleOptions = (response: StringRecord, rules?: ToastRule[]): boolean => {
  if (!rules) return true;

  return rules.every((rule) => {
    const responseValue = response[rule.key];
    const { expectedValue, operator = 'equals' } = rule;

    switch (operator) {
      case 'equals':
        return responseValue === expectedValue;
      case 'notEquals':
        return responseValue !== expectedValue;
      case 'includes':
        if (typeof responseValue === 'string' && typeof expectedValue === 'string') {
          return responseValue.includes(expectedValue);
        }
        return false;
      case 'greaterThan':
        if (typeof responseValue === 'number' && typeof expectedValue === 'number') {
          return responseValue > expectedValue;
        }
        return false;
      case 'lessThan':
        if (typeof responseValue === 'number' && typeof expectedValue === 'number') {
          return responseValue < expectedValue;
        }
        return false;
      default:
        return responseValue === expectedValue;
    }
  });
};
